module.exports = {
  title: 'Form Button Submit Field',
  context: {
    text: 'Submit',
    title: 'Submit Email Signup',
    class: 'secondary',
  },
  variants: [
    {
      name: 'Search Submit',
      context: {
        text: 'Search',
        url: '/',
        class: 'search-submit'
      }
    },
  ]
}